import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, List, VideoModal } from '@pella/sash-framework';
import { Image, CTA } from '../../';
import { isValidArray } from '../../utilities/validations';
import { getContrastColor } from '../../utilities/functions';

const ImageBanner = ({ data, className, ...other }) => {
	const [videoOpen, setVideoOpen] = useState(false);

	if (!data) return null;

	const onVideoCtaClick = (event) => {
		event.preventDefault();
		setVideoOpen(true);
	};

	const bgColor = data.background_hex_value || '#363636';
	const hasVideo = isValidArray(data.video);

	return (
		<div
			className={`imageBanner relative overflow-hidden ${className || ''}`}
			style={{ backgroundColor: bgColor }}
			{...other}
		>
			{isValidArray(data.image) && (
				<Image
					data={data.image[0]}
					className='imageBanner-image !block h-[300px] w-full sm:h-[400px] lg:h-[500px] xl:ml-auto xl:w-[65%]'
				/>
			)}

			<div className='imageBanner-contentWrapper w-full py-7 sm:absolute sm:left-0 sm:top-0 sm:z-2 sm:flex sm:h-full sm:items-center lg:py-0 xl:items-start'>
				<Container className='xl:h-full'>
					<div className='imageBanner-contentBox sm:max-w-[350px] sm:p-4 sm:max-xl:bg-black/80 sm:max-xl:shadow-[0_5px_10px_rgba(0,0,0,0.5)] lg:max-w-[750px] lg:p-7 xl:flex xl:h-full xl:max-w-[500px] xl:flex-wrap xl:content-center xl:items-center xl:pl-0'>
						{data.heading && (
							<h3
								className={`imageBanner-title mb-0 uppercase xl:flex-[0_1_100%] [&_a]:text-current [&_a]:decoration-current ${getContrastColor(bgColor)}`}
								dangerouslySetInnerHTML={{ __html: data.heading }}
							/>
						)}

						{data.description && (
							<div
								className={`imageBanner-desc mt-4 text-sm lg:text-base xl:flex-[0_1_100%] [&_*]:text-current [&_a]:decoration-current ${getContrastColor(bgColor)}`}
								dangerouslySetInnerHTML={{ __html: data.description }}
							/>
						)}

						{isValidArray(data.cta) && (
							<List
								bullets='none'
								layout='inline'
								className='imageBanner-ctas mt-7 items-center gap-y-2.5 sm:mt-5 sm:gap-x-5 lg:mt-7 xl:flex-[0_1_100%]'
							>
								{data.cta.map((link, index) => (
									<li
										key={index}
										className='max-sm:flex-12/12'
									>
										<CTA
											data={link}
											className={link.gtm_link_type !== 'button' || link.button_style === 'tertiary' ? 'text-white' : null}
											onClick={hasVideo ? onVideoCtaClick : null}
										/>
									</li>
								))}
							</List>
						)}
					</div>
				</Container>
			</div>

			{hasVideo && (
				<VideoModal
					videoId={data.video[0].video.video_id}
					title={data.video[0].video.title}
					transcript={data.video[0].transcript}
					isOpen={videoOpen}
					onClose={() => setVideoOpen(false)}
				/>
			)}
		</div>
	);
};

ImageBanner.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default ImageBanner;
